import './standalone.scss';

import React, { useEffect, useState } from 'react';
import { PaginationListStandalone } from 'react-bootstrap-table2-paginator';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

interface CustomPaginationProps {
  paginationProps: {
    page: number;
    sizePerPage: number;
    totalSize: number;
    onPageChange: (page: number) => void;
  };
  manual?: boolean;
}

const StandalonePagination: React.FC<CustomPaginationProps> = ({
  paginationProps,
  manual = false,
}) => {
  const { page, totalSize, sizePerPage, onPageChange } = paginationProps;

  const totalPages = Math.ceil(totalSize / sizePerPage);
  const [inputPage, setInputPage] = useState(page);

  useEffect(() => {
    setInputPage(page);
  }, [page]);

  const handleGo = () => {
    if (inputPage >= 1 && inputPage <= totalPages) {
      onPageChange(inputPage);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleGo();
    }
  };

  const visiblePages = Array.from(
    { length: Math.min(5, totalPages) },
    (_, index) => {
      const start = Math.min(
        Math.max(page - 2, 1),
        Math.max(totalPages - 4, 1)
      );
      return start + index;
    }
  );

  return (
    <div className="standalone-pagination">
      {manual ? (
        <Pagination aria-label="Recognition image pages">
          <PaginationItem disabled={page <= 1}>
            <PaginationLink
              previous
              aria-label="Previous page"
              onClick={() => onPageChange(Math.max(page - 1, 1))}
            />
          </PaginationItem>
          {visiblePages.map((pageNumber) => (
            <PaginationItem active={pageNumber === page} key={pageNumber}>
              <PaginationLink onClick={() => onPageChange(pageNumber)}>
                {pageNumber}
              </PaginationLink>
            </PaginationItem>
          ))}
          <PaginationItem disabled={page >= totalPages}>
            <PaginationLink
              next
              aria-label="Next page"
              onClick={() => onPageChange(Math.min(page + 1, totalPages))}
            />
          </PaginationItem>
        </Pagination>
      ) : (
        <PaginationListStandalone {...paginationProps} />
      )}

      {totalPages > 1 && (
        <div className="standalone-pagination__jump">
          <label htmlFor="go-to-page">Go to</label>

          <input
            id="go-to-page"
            type="number"
            className="form-control"
            value={inputPage}
            onChange={(event) => setInputPage(Number(event.target.value))}
            onKeyDown={handleKeyDown}
            min={1}
            max={totalPages}
            aria-label={`Go to page, between 1 and ${totalPages}`}
          />

          <button
            type="button"
            className="btn standalone-pagination__go"
            onClick={handleGo}
          >
            Go
          </button>
        </div>
      )}
    </div>
  );
};

export default StandalonePagination;
